import { useState, useEffect } from 'react';
import StartScreen from './components/StartScreen';
import LoadingScreen from './components/LoadingScreen';
import ResultsPage from './components/ResultsPage';

export default function HomePage() {
  const [currentScreen, setCurrentScreen] = useState<'start' | 'loading' | 'results'>('start');
  const [username, setUsername] = useState('');

  const handleStartClick = (nick: string) => {
    setUsername(nick);
    setCurrentScreen('loading');
  };

  useEffect(() => {
    if (currentScreen === 'loading') {
      const timer = setTimeout(() => {
        setCurrentScreen('results');
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [currentScreen]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0e27] via-[#1a1f3a] to-[#0a0e27] relative overflow-x-hidden">
      {/* Animated background particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`,
              opacity: Math.random() * 0.5 + 0.2,
            }}
          />
        ))}
      </div>

      {/* Dot grid pattern */}
      <div 
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)',
          backgroundSize: '50px 50px',
        }}
      />

      {currentScreen === 'start' && <StartScreen onStart={handleStartClick} />}
      {currentScreen === 'loading' && <LoadingScreen />}
      {currentScreen === 'results' && <ResultsPage username={username} />}
    </div>
  );
}
